import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '../../lib/utils';

type SeparatorProps = React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
  thickness?: string;
};

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(
  (
    { className, orientation = 'horizontal', decorative = true, thickness = '1px', ...props },
    ref
  ) => {
    // Tailwind JIT cannot see template literals — use literal utilities so height/width exist in CSS.
    const horizontalSize =
      thickness === '2px' ? 'h-[2px] w-full' : thickness === '1px' ? 'h-px w-full' : 'h-px w-full';
    const verticalSize =
      thickness === '2px' ? 'h-full w-[2px]' : thickness === '1px' ? 'h-full w-px' : 'h-full w-px';

    return (
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          'bg-border shrink-0',
          orientation === 'horizontal' ? horizontalSize : verticalSize,
          className
        )}
        {...props}
      />
    );
  }
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
